module.exports = __webpack_public_path__ + "img/delivery.4cf78fb9.png";